/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DocumentTypeCarrierRegistration = {
    DriverLicense: 'DRIVER_LICENSE',
    VehicleRegistration: 'VEHICLE_REGISTRATION',
    Insurance: 'INSURANCE',
    Ss4: 'SS4',
    TwicFront: 'TWIC_FRONT',
    TwicBack: 'TWIC_BACK',
    Iacssp: 'IACSSP'
} as const;
export type DocumentTypeCarrierRegistration = typeof DocumentTypeCarrierRegistration[keyof typeof DocumentTypeCarrierRegistration];

